import { render, staticRenderFns } from "./supPayAccount.vue?vue&type=template&id=58115b54"
import script from "./supPayAccount.vue?vue&type=script&lang=js"
export * from "./supPayAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports